'use client'

import { ChakraProvider } from '@chakra-ui/react'
import type { ColorModeProviderProps } from '@/shared/ui/color-mode'
import { ColorModeProvider } from '@/shared/ui/color-mode'
import { system } from '@/shared/lib/chakra/theme'
import { Toaster } from '@/shared'

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider {...props} />
      <Toaster />
    </ChakraProvider>
  )
}
